import React from 'react';
import { SearchCircleIcon } from '@heroicons/react/outline';
import ModernFooter from './modern/ModernFooter';

// Board-specific bits only; the design is shared (src/components/modern, 2026-10-02 refresh).
export default function Footer() {
  return <ModernFooter logo={<SearchCircleIcon className="h-9 w-9 text-white" aria-hidden="true" />} />;
}
